/* SkuEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("../CommonEditor");
const getDefaultCreateValue = require("./mapDataUtil");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const InputTextControl = uiCore.Control.Textfield.InputText;

class SkuEditor extends CommonEditor {
    constructor(args) {
        super(args);
        if (!this._itemData.regex) {
            this.rootElement.classList.add("select");
        }
    }

    _init() {
        if (!this._itemData.regex) {
            const gluSkus = _.get(this._itemData, "allGluSkus", []);
            const gluVendor = _.get(this._itemData, "vendor", "ALL");
            const opts = this.getDropdownOpts(gluVendor, gluSkus);
            this.input.setOptions(opts);
        }

        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        if (item.regex) {
            item.skuRegex = state;
        } else {
            item.skuValue = state;
            item.netBoxName = getDefaultCreateValue(
                item.vendor,
                item.skuValue,
                item.vendorOptions,
                [],
                false
            );
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        // console.log(this._itemData);
        if (this._itemData.regex) {
            return new InputTextControl({
                darkTheme: true,
            });
        } else {
            return new SingleComboBoxControl({
                showFilter: true,
                darkTheme: true,
                adjustWidth: true,
                allowClear: false,
            });
        }
    }

    show() {}
    hide() {}

    getDropdownOpts(vendor = "ALL", gluSkus) {
        const skus = gluSkus[vendor] || [];
        return skus.map((sku) => {
            return {
                label: sku,
                value: sku,
            };
        });
    }
}

module.exports = SkuEditor;
